export const ElectricUtilityServiceUrl =
	'https://services3.arcgis.com/943LBv9FP414WfDO/arcgis/rest/services/ELECTRIC_UTILITY_SERVICE_AREA_MI_WFL1/FeatureServer/16';

export interface ElectricUtility {
	id: number;
	name: string;
	website: string | undefined;
	phone: string | undefined;
}

function getContactValue(value: unknown): string | undefined {
	return typeof value === 'string' ? value.trim() || undefined : undefined;
}

export async function getElectricUtilities(longitude: number, latitude: number): Promise<ElectricUtility[]> {
	if (
		!Number.isFinite(longitude) ||
		!Number.isFinite(latitude) ||
		Math.abs(longitude) > 180 ||
		Math.abs(latitude) > 90
	) {
		throw new Error('Invalid premise coordinates for electric utility lookup');
	}

	const [{ default: Point }, { executeQueryJSON }] = await Promise.all([
		import('@arcgis/core/geometry/Point'),
		import('@arcgis/core/rest/query'),
	]);
	const result = await executeQueryJSON(ElectricUtilityServiceUrl, {
		geometry: new Point({ longitude, latitude, spatialReference: { wkid: 4326 } }),
		spatialRelationship: 'intersects',
		outFields: ['OBJECTID', 'Name', 'Website', 'Phone'],
		returnGeometry: false,
	});

	if (result.exceededTransferLimit) {
		throw new Error('Electric utility lookup returned an incomplete list of providers');
	}

	return result.features.map((feature) => {
		const attributes: Record<string, unknown> = feature.attributes;
		const name = getContactValue(attributes['Name']);
		const id = attributes['OBJECTID'];
		if (!name || typeof id !== 'number') {
			throw new Error('Electric utility lookup returned an invalid provider');
		}

		const website = getContactValue(attributes['Website']);
		if (website && !/^https?:\/\//i.test(website)) {
			throw new Error(`Electric utility lookup returned an invalid website for ${name}`);
		}

		return { id, name, website, phone: getContactValue(attributes['Phone']) };
	});
}
